import { render, staticRenderFns } from "./BooleanColumnTable.vue?vue&type=template&id=2db4b8e2&scoped=true&"
import script from "./BooleanColumnTable.vue?vue&type=script&lang=js&"
export * from "./BooleanColumnTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db4b8e2",
  null
  
)

export default component.exports